import { ReactElement, ReactNode, useState } from "react"
import { v4 as uuid4 } from "uuid"

import CreateAcuDeviceProvider from "./baseProviders/createAcuDeviceProvider"
import { useGetUserData } from "../../../../../hooks/useGetUserData"
import { getEmptyHpDeviceFormData } from "../../formSpecs/hpSpec"
import { HpDeviceFormData } from "../../types/providerTypes"

interface IPublishAcuDeviceProviderProps {
    children: ReactNode
}

/** Provider for the publish Air Conditioning Unit device form */
const PublishAcuDeviceProvider = ({
    children,
}: IPublishAcuDeviceProviderProps): ReactElement => {
    const [formData, setFormData] = useState<HpDeviceFormData>(
        getEmptyHpDeviceFormData()
    )

    const { isEnaSysAdmin } = useGetUserData()

    const [attachmentUUID] = useState<string>(uuid4())

    return (
        <CreateAcuDeviceProvider
            formData={formData}
            setFormData={setFormData}
            formDataIsLoading={false}
            canEditManufacturer={isEnaSysAdmin}
            attachmentUUID={attachmentUUID}
        >
            {children}
        </CreateAcuDeviceProvider>
    )
}

export default PublishAcuDeviceProvider
